import React, { useMemo } from 'react';

import './ratings-chart.scss';

interface RatingsChartProps {
  className?: string;
  formattedValue?: string;
  hideFill?: boolean;
  hideLegendNumbers?: boolean;
  hideValue?: boolean;
  hideValueMarker?: boolean;
  scale?: number;
  showZeroValue?: boolean;
  value?: number;
  valueMarker?: React.ReactNode;
}

function RatingsChart(props: RatingsChartProps) {
  const {
    className = '',
    formattedValue: formattedValueProp,
    hideFill = false,
    hideLegendNumbers = false,
    hideValue = false,
    hideValueMarker = false,
    scale = 5,
    showZeroValue = false,
    value = 0,
    valueMarker
  } = props;
  const multiplier = 100 / scale;
  const widthPercentage = Math.max(0, value) * multiplier;
  const formattedValue =
    typeof value?.toFixed === 'function' ? value.toFixed(1) : value;
  const displayValue = formattedValueProp || formattedValue;

  const { legendArray = [], markerArray = [] } = useMemo(() => {
    const legendArray = Array.from({ length: scale + 1 }, (_, i) => i);
    const markerArray = legendArray.slice(1, -1);

    return { legendArray, markerArray };
  }, [scale]);

  return (
    <div className={`ratings-chart ${className}`} styleName="container">
      <div
        className="ratings-chart__background-outline"
        styleName="background-outline"
      >
        <div className="ratings-chart__background" styleName="background">
          {!hideFill && (
            <div
              className="ratings-chart__fill"
              style={{ width: `${widthPercentage}%` }}
              styleName="fill"
            />
          )}
          <div styleName="marks">
            {markerArray.map(number => (
              <span
                className="ratings-chart__mark"
                key={number}
                styleName="mark"
              />
            ))}
          </div>
        </div>
      </div>
      {!hideLegendNumbers && (
        <div className="ratings-chart__series" styleName="series">
          {legendArray.map(number => (
            <span key={number} styleName="legend">
              {number}
            </span>
          ))}
        </div>
      )}

      {(value !== 0 || showZeroValue) && (
        <div
          className="ratings-chart__value"
          data-testid="ratings-chart__value"
          style={{
            left: `${widthPercentage}%`
          }}
          styleName="value"
        >
          {!hideValue && displayValue}
          {!valueMarker && !hideValueMarker ? (
            <>
              <span className="ratings-chart__triangle" styleName="triangle" />
              <span
                className="ratings-chart__value-mark"
                styleName="value-mark"
              />
            </>
          ) : (
            valueMarker
          )}
        </div>
      )}
    </div>
  );
}

export default RatingsChart;
